export const environment = {
  production: false,
    maestroApi: 'https://homologacao.vivest.com.br/apis/api-bi-maestro/',
  configSite: {
    endPointAPI: 'https://www3.vivest.com.br/',
    endPointAPP: 'api/content/site-settings/',
    CLIENT_ID: 'vivest-portal:front-end',
    CLIENT_SECRET: 'dIMIXVijJtiW8gXwN6pKWtnwJH4h4/hxSVBv4MeuTDI=',
  },
  configCMS: {
    endPointAPI: 'https://www3.vivest.com.br/',
    endPointAPP: 'api/content/vivest-portal/',
    endPointAssets: 'https://www3.vivest.com.br/api/assets/vivest-portal/',
    CLIENT_ID: 'vivest-portal:front-end',
    CLIENT_SECRET: 'yxOgGoWDhKIuEDLy9DZnzDIxnk9NnPNPnHD5Cp6OMLo='
  },
  configAzure: {
    endPointAPI: 'https://portal-vivest-hmg.search.windows.net/indexes/general-pages-content/docs',
    endPointSearch: 'indexes/general-pages-content/docs',
    versionAPI: '2020-06-30',
    keyAPI: '9881151A3D8A36648137EAD11D847BE5'
  },
  appInsights: {
    key: '1122d4c5-8c5d-4ad8-ae82-cab79ef3af0b'
  },
  redeCredenciadaUrl: 'http://redecred.prevcesp.com.br/redecredenciadadesenv/buscanovoportal/rede.asp?combo_rede_plano=',
  redeEssencialBaseUrl: 'https://www.vivest.com.br/assets/rede-essencial/',
  investmentReport: {
    endPointAPI: 'https://homologacao.vivest.com.br/apis/api-portal-relatorio-investimento',
    getCompany: '/v1/InvestmentReport/GetCompany',
    getPeriod: '/v1/InvestmentReport/GetPeriod',
    getInvestmentReportList: '/v1/InvestmentReport/getInvestmentReportList',
    getDocInvestmentReport: '/v1/InvestmentReport/getDocInvestmentReport',
    OcpApimSubscriptionKey: '5361ac77d875435a83b7d66e50ded604'
  },
  headerConfig: {
    showNavbarActions: true
  }
};
